// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root{
  margin-top: 130px;
  padding-left: 20px;
  padding-right: 20px;
}
.container {
    margin: 0;
    font-family: Arial, sans-serif;
    width: 100%;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .progress-bar {
    width: 70%;
    height: 15px;
    background-color: #1f7c50;
    border-radius: 5px;
  }
  
  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .table-container {
    width: 100%;
    margin: 0;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px 15px;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none;
    background-color: #1f7c50;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }

  .pagination-controls button:hover:not(:disabled) {
    background-color: #1a6b45;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination-controls span {
    font-size: 16px;
    margin-left: 10px;
  }
  
  .status-badge {
    padding: 5px 10px;
    border-radius: 12px;
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
  
  .status-badge-active {
    background-color: #1f7c50;
  }
  
  .status-badge-inactive {
    background-color: #ef4455;
  }
  
  .status-badge-pending {
    background-color: #eec240;
    color: black;
  }
  
  .action-button {
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: #1f7c50;
    border: 1px solid #1f7c50;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-without-border {
    padding: 2px 3px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: #dc3545;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-without-border:hover {
    background-color: rgba(31, 124, 80, 0.12);
    color: #1f7c50;
  }
  
  .action-button:hover {
    background-color: rgba(31, 124, 80, 0.15);
    color: #1f7c50;
  }
  
  .expand-icon {
    cursor: pointer;
    text-align: center;
  }

  .badge-status {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 12px;
  }
  

  .create-button {
    background-color: #1f7c50;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    height: 35px;
  }

  .create-button:hover {
    background-color: #1a6b45;
    color: white;
  }


  /* Qatar palette: #1f7c50 (dark green), #07ffa9 (bright teal), #101413, #accbc3 */
  .submit-button4,
  .submit-button4.btn-primary,
  .root .modal .btn-primary[type="submit"],
  .root .modal-footer .btn-primary {
    border: none !important;
    background-color: #1f7c50 !important;
    border-color: #1f7c50 !important;
    color: white !important;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button4:hover,
  .submit-button4.btn-primary:hover,
  .root .modal .btn-primary[type="submit"]:hover:not(:disabled),
  .root .modal-footer .btn-primary:hover:not(:disabled) {
    outline: none;
    background-color: #1a6b45 !important;
    border-color: #1a6b45 !important;
    color: white !important;
  }

  .btn-create {
    background-color: #1f7c50;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;
  }
  
  .btn-create:hover:enabled {
    background-color: #196b43;
    transform: translateY(-1px);
  }
  
  .btn-create:disabled {
    background-color: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
  }

  /* Qatar: secondary/cancel buttons - subtle border */
  .root .modal-footer .btn-secondary {
    border: 1px solid #accbc3;
    color: #1e293b;
    background-color: #fff;
  }
  .root .modal-footer .btn-secondary:hover {
    background-color: #f1f5f9;
    border-color: #1f7c50;
    color: #1f7c50;
  }`, "",{"version":3,"sources":["webpack://./src/pages/FunctionUser/style.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;IACI,SAAS;IACT,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;EAGA,iFAAiF;EACjF;;;;IAIE,uBAAuB;IACvB,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,8DAA8D;IAC9D,aAAa;IACb,uBAAuB;EACzB;;EAEA;;;;IAIE,aAAa;IACb,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8EAA8E;EAChF;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;EAEA,oDAAoD;EACpD;IACE,yBAAyB;IACzB,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB","sourcesContent":["\r\n.root{\r\n  margin-top: 130px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n.container {\r\n    margin: 0;\r\n    font-family: Arial, sans-serif;\r\n    width: 100%;\r\n  }\r\n  \r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .progress-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .progress-bar {\r\n    width: 70%;\r\n    height: 15px;\r\n    background-color: #1f7c50;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .badge-status {\r\n    display: inline-block;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .table-container {\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 10px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .table-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n    color: #333;\r\n  }\r\n  \r\n  .search-input {\r\n    width: 40%;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background-color: white;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 12px 15px;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f3f4f6;\r\n    color: #333;\r\n  }\r\n  \r\n  .clickable-row {\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .clickable-row:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .expanded-content {\r\n    padding: 10px;\r\n    background-color: #e9e9e9;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    text-align: center;\r\n  }\r\n  \r\n  .pagination-controls button {\r\n    padding: 8px 12px;\r\n    margin: 0 5px;\r\n    border: none;\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .pagination-controls button:hover:not(:disabled) {\r\n    background-color: #1a6b45;\r\n  }\r\n  \r\n  .pagination-controls button:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-controls span {\r\n    font-size: 16px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .status-badge {\r\n    padding: 5px 10px;\r\n    border-radius: 12px;\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .status-badge-active {\r\n    background-color: #1f7c50;\r\n  }\r\n  \r\n  .status-badge-inactive {\r\n    background-color: #ef4455;\r\n  }\r\n  \r\n  .status-badge-pending {\r\n    background-color: #eec240;\r\n    color: black;\r\n  }\r\n  \r\n  .action-button {\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #1f7c50;\r\n    border: 1px solid #1f7c50;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-without-border {\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #dc3545;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-without-border:hover {\r\n    background-color: rgba(31, 124, 80, 0.12);\r\n    color: #1f7c50;\r\n  }\r\n  \r\n  .action-button:hover {\r\n    background-color: rgba(31, 124, 80, 0.15);\r\n    color: #1f7c50;\r\n  }\r\n  \r\n  .expand-icon {\r\n    cursor: pointer;\r\n    text-align: center;\r\n  }\r\n\r\n  .badge-status {\r\n    display: inline-block;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n\r\n  .create-button {\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    height: 35px;\r\n  }\r\n\r\n  .create-button:hover {\r\n    background-color: #1a6b45;\r\n    color: white;\r\n  }\r\n\r\n\r\n  /* Qatar palette: #1f7c50 (dark green), #07ffa9 (bright teal), #101413, #accbc3 */\r\n  .submit-button4,\r\n  .submit-button4.btn-primary,\r\n  .root .modal .btn-primary[type=\"submit\"],\r\n  .root .modal-footer .btn-primary {\r\n    border: none !important;\r\n    background-color: #1f7c50 !important;\r\n    border-color: #1f7c50 !important;\r\n    color: white !important;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, border-color 0.3s ease;\r\n    outline: none;\r\n    height: 30px !important;\r\n  }\r\n  \r\n  .submit-button4:hover,\r\n  .submit-button4.btn-primary:hover,\r\n  .root .modal .btn-primary[type=\"submit\"]:hover:not(:disabled),\r\n  .root .modal-footer .btn-primary:hover:not(:disabled) {\r\n    outline: none;\r\n    background-color: #1a6b45 !important;\r\n    border-color: #1a6b45 !important;\r\n    color: white !important;\r\n  }\r\n\r\n  .btn-create {\r\n    background-color: #1f7c50;\r\n    color: #fff;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    padding: 8px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;\r\n  }\r\n  \r\n  .btn-create:hover:enabled {\r\n    background-color: #196b43;\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  .btn-create:disabled {\r\n    background-color: #e0e0e0;\r\n    color: #999;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n  }\r\n\r\n  /* Qatar: secondary/cancel buttons - subtle border */\r\n  .root .modal-footer .btn-secondary {\r\n    border: 1px solid #accbc3;\r\n    color: #1e293b;\r\n    background-color: #fff;\r\n  }\r\n  .root .modal-footer .btn-secondary:hover {\r\n    background-color: #f1f5f9;\r\n    border-color: #1f7c50;\r\n    color: #1f7c50;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
